module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_concept_01-d9d9e8724a8950cb6bd85c832c1dcf88.jpg";